export default function TrustSection() {
  const trustItems = [
    { icon: "ri-search-eye-line", title: "Independent Research", desc: "We conduct independent research and provide unbiased information to help shoppers make informed decisions without commercial influence." },
    { icon: "ri-book-open-line", title: "Educational Resource", desc: "Our content is designed as an educational hub — teaching users how to navigate spreadsheet shopping safely and effectively." },
    { icon: "ri-refresh-line", title: "Regular Updates", desc: "Content is updated regularly to ensure accuracy, relevance, and alignment with the latest spreadsheet shopping trends and best practices." },
    { icon: "ri-eye-line", title: "Transparent Information", desc: "We believe in full transparency — all sources, methodologies and affiliations are clearly disclosed across our platform." },
    { icon: "ri-shield-user-line", title: "User Safety Focus", desc: "Protecting our readers is paramount. Every guide includes safety tips and best practices for secure spreadsheet shopping." },
    { icon: "ri-team-line", title: "Community Driven", desc: "Built with input from real spreadsheet shoppers, our resources reflect genuine community needs and practical experience." },
  ];

  return (
    <section className="relative w-full py-20 md:py-28 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-14">
            <span className="inline-flex items-center gap-2 px-3 py-1 bg-accent-100 text-accent-800 text-xs font-semibold rounded-full mb-5 whitespace-nowrap">
              <i className="ri-verified-badge-line"></i>
              Why Trust Us
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4 text-balance">
              Your Trusted Spreadsheet<br />Shopping Resource
            </h2>
            <p className="text-base text-foreground-500 max-w-xl mx-auto">
              We are committed to providing reliable, well-researched, and up-to-date information for the spreadsheet shopping community
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {trustItems.map((item) => (
              <div key={item.title} className="flex items-start gap-4 p-6 rounded-2xl bg-background-50 border border-background-200/40">
                <span className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-100 flex-shrink-0">
                  <i className={`${item.icon} text-xl text-accent-600`}></i>
                </span>
                <div>
                  <h3 className="text-base font-bold text-foreground-950 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}